import type { MarketKind } from '../../types';
import type { FiltersByOutcomeParameterMap } from './types';

/**
 * Сортирует значения фильтров исходов:
 * - для рынков типа Handicap и Total с фильтром типа NUMERIC_PARAM_VALUE - по возрастанию
 * - для остальных рынков - по sortOrder
 * Устанвливает активное значение по умолчанию:
 * - для рынков типа Handicap и Total - значение из центра массива
 * - для остальных рынков - первое значение
 */
export function sortFiltersValues(
    filters: FiltersByOutcomeParameterMap,
    marketKind: MarketKind,
): FiltersByOutcomeParameterMap {
    for(const filter of filters.values()) {
        if (!filter.valuesMap.size) {
            continue;
        }

        /*
         * TODO: remove comment
         * вот тут тип же Map<OutcomeParameterValue, FilterValue>;
         * и в sortedValues попадает именно OutcomeParameterValue
         * протому что он v[0]
         * и везде далее, где берется нулевой элемент
         * и как будто неверно его называть value
         * или как минимум просто валюе
         */
        const values = [...filter.valuesMap.entries()];

        const sortedValues = values
            .sort((a, b) => a[1].sortOrder - b[1].sortOrder)
            .map((v) => v[0]);

        filter.values = sortedValues;

        filter.activeValue.value = values[0][0];

        // для рынков типа Handicap и Total устанавливаем активное значение из центра массива
        if (filter.kind === 'NUMERIC_PARAM_VALUE' && (marketKind === 'Handicap' || marketKind === 'Total')) {
            const middleIndex = Math.floor(values.length / 2);

            filter.activeValue.value = values[middleIndex][0];
        }
    }

    return filters;
}
